import styled from 'styled-components';

import media from 'apps/auth/theme/media';

export const Item = styled.div`
    padding-bottom: 24px;
    padding-left: 26px;
    position: relative;
    border-left: 2px ${(props) => (props.isPassed ? 'solid' : 'dotted')} ${(props) => (props.isPassed ? props.theme.purple_100 : props.theme.grey_40_lc)};

    &:last-child {
        padding-bottom: 0;
        border-color: transparent;
    }

    &:after {
        content: '';
        display: inline-block;
        position: absolute;
        top: 0;
        left: -7px;
        width: 12px;
        height: 12px;
        background: ${(props) => (props.isActive || props.isPassed ? props.theme.purple_100 : props.theme.white)};
        border: 2px solid ${(props) => (props.isActive || props.isPassed ? props.theme.purple_100 : props.theme.grey_40_lc)};
        border-radius: 50%;
        box-sizing: border-box;
    }
`;
export const ItemContent = styled.div`
    top: -6px;
    position: relative;

    ${media.desktop1920} {
        top: -10px;
    }
`;
export const StatusList = styled.div`
    margin-top: 6px;
    margin-left: 12px;
`;
export const IconWrap = styled.span`
    position: absolute;
    top: -6px;
    left: -13px;
    background: ${(props) => props.theme.white};
    z-index: 1;
    display: inline-block;
    width: 24px;
    height: 24px;
`;
